import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/uiDir/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/uiDir/card";

const Support = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="max-w-4xl mx-auto">
          <div className="mb-10">
            <h1 className="text-4xl font-heading font-bold mb-2">Support</h1>
            <p className="text-muted-foreground">
              Get help with your account, projects, and sharing tools.
            </p>
          </div>

          <div className="space-y-6">
            <Card className="glass-card">
              <CardHeader>
                <CardTitle>Account Help</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                Manage your login details, password, and profile preferences.
              </CardContent>
            </Card>

            <Card className="glass-card">
              <CardHeader>
                <CardTitle>Portfolio Sharing</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                Use the share page to copy links and generate QR codes for your work.
              </CardContent>
            </Card>

            <Card className="glass-card">
              <CardHeader>
                <CardTitle>Contact</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                Reach out through the email link in the footer for direct assistance.
              </CardContent>
            </Card>
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/docs">
              <Button variant="outline">View Documentation</Button>
            </Link>
            <Link to="/">
              <Button variant="ghost">Back to Home</Button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Support;
